export const experience = [
  {
    id: 1,
    title: 'Principal Software Engineer',
    company: 'Healthcare SaaS Platform',
    location: 'Vancouver, British Columbia, Canada · Remote',
    current: false,
    description: 'Spearheading the evolution of backend architecture to scale system performance and support rapid product growth, driving long-term platform resiliency.',
    responsibilities: [
      'Spearheaded the evolution of backend architecture to scale system performance and support rapid product growth, driving long-term platform resiliency',
      'Acted as a hands-on technical leader—balancing architectural decisions with day-to-day implementation, debugging, and mentoring',
      'Mentored senior engineers across cross-functional teams, fostering technical ownership and upskilling through design reviews, pair programming, and onboarding programs',
      'Advocated for and implemented agile best practices, including continuous delivery, trunk-based development, and automated deployment pipelines',
      'Delivered high-quality solutions to complex system problems through Domain Driven Design/Service Oriented Architecture, clear documentation, and a focus on maintainability'
    ],
    technologies: ['Backend Architecture', 'System Design', 'Mentoring', 'Agile', 'CI/CD', 'Domain Driven Design', 'Service Oriented Architecture'],
    achievements: [
      'Scaled backend architecture to support rapid product growth',
      'Established technical leadership across cross-functional teams',
      'Implemented continuous delivery and automated deployment pipelines'
    ]
  },
  {
    id: 2,
    company: 'High-Traffic Social Platform',
    location: 'Singapore, Singapore',
    current: false,
    description: 'Seven years and two promotions at a high-traffic social-platform company — growing from Senior Engineer to Technical Lead across the payments and serverless platform teams.',
    roles: [
      {
        title: 'NodeJS/TypeScript Technical Lead',
        summary: 'Led serverless architecture and engineering OKRs across TypeScript services; drove major AWS cost-savings initiatives and enforced test-driven development.'
      },
      {
        title: 'PHP Technical Lead (Payments)',
        summary: 'Owned payment-gateway integrations (Stripe, PayPal, RocketGate, InovioPay) and APIs processing >$100k/day; led Laravel 8 / PHP 8 upgrades and SOLID refactors.'
      },
      {
        title: 'Senior Software Engineer',
        summary: 'Built core high-traffic, big-data modules across Laravel, ElasticSearch, Node, and React; introduced serverless AWS patterns and mentored junior engineers.'
      }
    ],
    technologies: ['TypeScript', 'Node.js', 'AWS', 'Serverless', 'PHP', 'Laravel', 'ElasticSearch', 'React.js'],
    achievements: [
      'Promoted twice in 7 years — Senior Engineer → Technical Lead',
      '40% cost savings via map-provider migration; 30% via fan-out architecture',
      'Payment APIs processing >$100k gross revenue per day'
    ]
  },
  {
    id: 5,
    title: 'Development Team Leader',
    company: 'Travel Tech Marketplace',
    location: 'Manila, Philippines',
    current: false,
    description: 'Promoted from Fullstack PHP Developer to Development Team Leader within 6 months for outstanding performance. Led backend, frontend and QA professionals.',
    responsibilities: [
      'Spearheaded the growing requirements of the platform',
      'Provided vision and leadership to backend, frontend and quality analyst professionals',
      'Implemented scalable infrastructure using Git, Distelli CI, Laravel, AWS, React.js, AngularJS',
      'Involved with recruitment and team organization',
      'Provided overall leadership and technical vision'
    ],
    technologies: ['PHP', 'Laravel', 'React.js', 'AngularJS', 'AWS', 'Git'],
    achievements: [
      'Promoted to Team Leader within 6 months for outstanding performance',
      'Successfully scaled the development team',
      'Implemented efficient delivery system for modules'
    ]
  },
  {
    id: 6,
    title: 'PHP Developer',
    company: 'E-Commerce Startup',
    location: 'Manila, Philippines',
    current: false,
    description: 'One of pioneer developers that created the E-Commerce website from the ground up using multiple web technologies and frameworks.',
    responsibilities: [
      'Created E-Commerce website from ground up using CodeIgniter2, Symfony2, Laravel4, Node.js',
      'Produced RESTful APIs for mobile platform endpoints',
      'Spearheaded webpage optimization by implementing modular components',
      'Converted codebase into more scalable architecture',
      'Enabled faster turnarounds for development requirements'
    ],
    technologies: ['PHP', 'CodeIgniter', 'Symfony', 'Laravel', 'Node.js', 'ElasticSearch', 'MySQL', 'Redis', 'MongoDB'],
    achievements: [
      'Successfully built E-Commerce platform from scratch',
      'Created RESTful APIs consumed by mobile development team',
      'Improved codebase scalability and development speed'
    ]
  }
]

export const getCurrentPosition = () => {
  return experience.find(exp => exp.current)
}

export const getAllTechnologies = () => {
  const techs = new Set()
  experience.forEach(exp => {
    exp.technologies.forEach(tech => techs.add(tech))
  })
  return Array.from(techs)
}